/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ScorePewsViewerAliases {
  ACTION_INACTIVATE_SCORE_PEWS = 'action-inactivate-score-pews',
  ACTION_NEW_SCORE_PEWS = 'action-new-score-pews',
  ACTION_REFERENCE_SCORE_PEWS = 'action-reference-score-pews',
  CHECKBOX_NEBULIZATION = 'checkbox-nebulization',
  CHECKBOX_VOMIT = 'checkbox-vomit',
  CONTEXTUAL_BAR = 'contextual-bar',
  FIELD_CARDIOVASCULAR = 'field-cardiovascular',
  FIELD_EVALUATION_DATE = 'field-evaluation-date',
  FIELD_NEBULIZATION = 'field-nebulization',
  FIELD_NEUROLOGICAL = 'field-neurological',
  FIELD_PROFESSIONAL = 'field-professional',
  FIELD_PUNCTUATION = 'field-punctuation',
  FIELD_RESPIRATORY = 'field-respiratory',
  FIELD_RESULT = 'field-result',
  FIELD_VOMIT = 'field-vomit',
  FORM_SCORE_PEWS_VIEWER = 'form-score-pews-viewer',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INPUT_EVATUALION_DATE = 'input-evatualion-date',
  LAYOUT_SCORE_PEWS_VIEWER = 'layout-score-pews-viewer',
  TEXT_CARDIOVASCULAR = 'text-cardiovascular',
  TEXT_NEUROLOGICAL_STATUS = 'text-neurological-status',
  TEXT_PROFESSIONAL = 'text-professional',
  TEXT_PUNCTUATION = 'text-punctuation',
  TEXT_RESPIRATORY = 'text-respiratory',
  TEXT_RESULT = 'text-result',
}
export { ScorePewsViewerAliases };
